import { useMemo } from 'react';
import { useStoreContext } from '../providers/TrainProvider';
/**
 * Null-safe wrapper around the swap store.
 *
 * Returns stable, memoized accessors and actions so hooks don't need to
 * repeat `store?.getState().…` boilerplate or handle null-checks themselves.
 *
 * For reactive (subscription-based) reads, use `useStore(store, selector)`
 * or `useSyncExternalStore` directly — this hook is for point-in-time reads
 * and fire-and-forget mutations inside callbacks.
 */
export function useSwapActions() {
    const store = useStoreContext();
    return useMemo(() => ({
        // --- Point-in-time reads ---
        getSwap: (hashlock) => store?.getState().getSwap(hashlock),
        getSwapFlags: (hashlock) => store?.getState().getSwapFlags(hashlock),
        getOrderData: (hashlock) => store?.getState().getOrderData(hashlock),
        // --- Mutations ---
        addSwap: (hashlock, data) => store?.getState().addSwap(hashlock, data),
        updateSwap: (hashlock, updates) => store?.getState().updateSwap(hashlock, updates),
        clearSwap: (hashlock) => store?.getState().clearSwap(hashlock),
        updateSwapFlags: (hashlock, updates) => store?.getState().updateSwapFlags(hashlock, updates),
        markVerifiedManually: (hashlock) => store?.getState().markVerifiedManually(hashlock),
        setOrderData: (hashlock, data) => store?.getState().setOrderData(hashlock, data),
        // --- Lifecycle ---
        subscribe: (hashlock) => store?.getState().subscribe(hashlock),
        unsubscribe: (hashlock) => store?.getState().unsubscribe(hashlock),
    }), [store]);
}
